import { loadUserActivitySettings } from 'common/user_activity/sagas';
import { takeEvery } from 'redux-saga/effects';
import * as Actions from 'common/notifications/actions/PreferenceActions';
import * as Reducers from 'common/notifications/reducers/PreferenceReducer';

export default [
  takeEvery(
    Actions.LOAD_USER_ACTIVITY_SETTINGS,
    loadUserActivitySettings(
      Actions.loadUserActivitySettingsSuccess,
      Actions.loadUserActivitySettingsFailure,
      {},
    ),
  ),
];
